import React from "react";
import NavUp from "../../../commons/NavUp";
import "../../../pages/Home/Component/Card.css";
import NavbarTechnician from "../../../commons/NavbarTechnician";
import firebaseManager from '../../../model/Firebase/FirebaseManager'
import Cards from "./Component/Cards";
import Title from '../../../pages/Login/Components/title/title'

class HomeTechnician extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props)
  {
      super();
      this.handleJob = this.handleJob.bind(this);
      this.state={
         dents : []
      }
    this.getDentuser()
  }

  
  getDentuser(){
    firebaseManager.getDentInfoForCurrentUser(this.getDentIdsCallback)
  }
  
  getDentIdsCallback = (dentIds) => {
    if (dentIds) {
      dentIds.map((dentId) => {
        return firebaseManager.getDentInfoForCard(dentId, this.dentInfoCallback)
       })
    }
  }
  
  dentInfoCallback = (dentInfo) => {
   if (dentInfo.status === 'nfix' ||dentInfo.status === 'fixed' || dentInfo.status === 'payment' || dentInfo.status === 'confirmed' || dentInfo.status === 'progress')  {
    this.setState({
      dents : this.state.dents.concat([dentInfo])
    })
    let noJobs = document.getElementById('noJobs')
    noJobs.classList.add('d-none')
  }
  }

  handleJob() {
    firebaseManager.confirmStartJob(this.successStartJob,this.failStartJob)
  }

  successStartJob = () => {
    window.location="/homeTechnician"
  }
  
  failStartJob (error) {
    alert(error.message)
  }

  render() {
    const reload = () => {
      window.location.reload()
  }
    return (
      <React.Fragment>
        <NavUp />
        <div id="noJobs" className="">
        <Title text1="No work in progress" />
        </div>
        <div className="mt-5">
        <div id="btnCard" className="text-center">
                {this.state.dents.map((dentInfo) =>
                  <Cards key = {dentInfo.dent_id} dentInfo = {dentInfo} />
                )}
            </div>
            <div id = "datos"></div>
            <div className ="text-center">
                <button onClick={this.handleJob} id="btnStartJob" className="btn btn-secondary mx-auto mt-2 mb-2 d-blo d-none">Start job</button>
            </div>
            <div className ="text-center mb-5">
                <button onClick={reload} id="btnHome" className="btn btn-secondary mx-auto mt-2 mb-5 d-blo d-none">Back to home</button>
            </div>
          <NavbarTechnician />
        </div>
      </React.Fragment>
    );
  }
}

export default HomeTechnician;
